import { render, staticRenderFns } from "./MarketConfigItems.vue?vue&type=template&id=2e15be9e&"
import script from "./MarketConfigItems.vue?vue&type=script&lang=ts&"
export * from "./MarketConfigItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports